import React, {useRef, useState, useEffect} from "react";
import { Marker, Popup, CircleMarker } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import L from "leaflet";
import { envoyerEmailOuVerification } from "./VerifierEmail";
import { ES_Horaires_Ouverture } from "./ES_Horaires_Ouverture";
import { fetchPSdansEtablissement, fetchModifications } from "./Fonctions_Communications_API";
import { Recuperer_coord_avec_adresse } from "./Fonctions_Geolocalisation";
import '../css/ES_Markers.css'


const EtablissementsMarkers = ({
  filteredData,
  selectedSousCategories,
  selectedCategories,
  logoSousCategories,
  expandedBubbles,
  utilisateurVeutModifier,
  setUtilisateurVeutModifier,
  email,
  setEmail,
  modifPermise,
  showMenuLateral,
  setShowMenuLateral,
  setOuvrirFenetreModifications,
  setEstablishmentToModify,
  openURL,
  coordonnéesPointCentral,
  afficherClusters, 
  setAfficherPanneauInfoSupplementaires,
  afficherPanneauInfoSupplementaires,
  setNumeroFiness,
  isPhone,  
  afficherPopupSiteWeb,
  setAfficherPopupSiteWeb,
  selectedEstablishment,
  setSelectedEstablishment,
  afficherModalMigrationPraticiens,
  setAfficherModalMigrationsPraticiens,
  afficherModalAjoutPraticien,
  setAfficherModalAjoutPraticien,
  establishmentDepuisLequelLePraticienMigre,
  setPraticienAMigrer,
  setEstablishmentDepuisLequelLePraticienMigre,
  afficherEtatModifications,
  showThankYouModal
}) => {
  const [scrollDownDemanded, setScrollDownDemanded]=useState(false)
  const scrollableDivRef = useRef(null); 
  const [popupProSante, setPopupProSante] = useState(false);
  

  useEffect(() => {
    if (scrollableDivRef.current) {
      
        scrollableDivRef.current.scrollTo({
          top: scrollableDivRef.current.scrollHeight,
          behavior: "smooth",
        });
      
    }
  }, [scrollDownDemanded, popupProSante]);

  
  

  const [personnesTravaillantDansEtablissement,setPersonnesTravaillantDansEtablissement]=useState([])
  
  const cherchertravailleurs = async (establishment)=>{
    await fetchPSdansEtablissement(establishment.finess_et, setPersonnesTravaillantDansEtablissement);
    setPopupProSante(!popupProSante);
  }



  
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortedData, setSortedData] = useState(personnesTravaillantDansEtablissement);

  const handleSort = () => {
    const newOrder = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(newOrder);

    const sorted = [...sortedData].sort((a, b) => {
      
      const professionCompare = a.profession.localeCompare(b.profession);
      
      if (professionCompare !== 0) {
        return newOrder === "asc" ? professionCompare : -professionCompare;
      }
      
      
      return a.nom.localeCompare(b.nom);
        
    });

    setSortedData(sorted);
  };

  useEffect(() => {
    setSortedData(personnesTravaillantDansEtablissement);
  }, [personnesTravaillantDansEtablissement]);


  
  

  


  
  
  const handleOpenURL = (establishment) => {
    
    if (establishment.site_web) {
      window.open(establishment.site_web, "_blank");
    } else {
      setSelectedEstablishment(establishment);
      setAfficherPopupSiteWeb(true);
    }
  };

  const handleMigrer=(personne, establishment)=>{
    setAfficherModalMigrationsPraticiens(true);
    setPraticienAMigrer(personne);
    setEstablishmentDepuisLequelLePraticienMigre(establishment)
  }


  const handleAjouterPraticien = (establishment) => {
    setAfficherModalAjoutPraticien(true);
    setEstablishmentDepuisLequelLePraticienMigre(establishment)
  }

  const [modificationsHistoriques, setModificationsHistoriques] = useState([]);

  useEffect(() => {
    if (afficherEtatModifications) {
      fetchModifications(setModificationsHistoriques);
    }
  }, [afficherEtatModifications]);

  

  const markers = filteredData.map((establishment, index) => (
    <div>
      
    <Marker
      key={index}
      position={establishment.coords}
      
      eventHandlers={{
        click: () => {
          setPopupProSante(false); 
          setUtilisateurVeutModifier(false);
          setAfficherPanneauInfoSupplementaires(false);
        }
      }}
      icon={L.icon({
        iconUrl: logoSousCategories.includes(establishment.sous_categorie)
          ? `marqueurs_finaux_finess/${establishment.sous_categorie}.png`
          : "marker_bleu_fond.png",
        iconSize: expandedBubbles.includes(establishment.sous_categorie)
          ? [60, 60]
          : [40, 40],
        iconAnchor: expandedBubbles.includes(establishment.sous_categorie)
          ? [30, 60]
          : [20, 40],
        popupAnchor: [0, -30],
        shadowUrl: "marker_shadow.png",
        shadowSize: [41, 41],
        className: afficherEtatModifications && 
           !modificationsHistoriques.some(etablissementModifié => 
             etablissementModifié.numero_finess === establishment.finess_et
           ) 
           ? "grayscale-marker" 
           : null
      })}
      
    >
      
      
      <Popup closeOnClick={false} onClose={()=>setPopupProSante(false)} minWidth="auto">
        {!utilisateurVeutModifier ? (
          !popupProSante ? (
          <div className="popup-content" ref={scrollableDivRef}>
            <div className="popup-title-header">
              <p className="popup-title">{establishment.nom}</p>
            </div>
            <p className="popup-address">
              <img src="adresse.png" alt="Adresse" className="popup-icon" title="Adresse"/>
              {establishment.adresse_finale}
            </p>

            <p className="popup-label">
              <img src="menu.png" alt="Catégorie" className="popup-icon" title="Catégorie"/>
              {establishment.sous_categorie}
            </p>

            {establishment.telephone ? (
              <p className="popup-label">
                <img src="telephone.png" alt="Téléphone" className="popup-icon" title="Numéro de téléphone"/>
                {establishment.telephone}
              </p>
            ) : (
              <p className="popup-label">
                <img src="telephone.png" alt="Téléphone" className="popup-icon" />
                Numéro de téléphone non renseigné
              </p>
            )}
            {establishment.horaires && establishment.horaires.length > 0 ? (
            <ES_Horaires_Ouverture horaires={establishment.horaires} scrollDownDemanded={scrollDownDemanded} setScrollDownDemanded={setScrollDownDemanded}/>
          ) : (
            <p className="popup-label"><i>Horaires non renseignés</i></p>
          )}

            

            <div className="popup-bouton-div">
              {!isPhone && (
            <button
                className="popup-button"
                onClick={() => {setNumeroFiness(establishment.finess_et); setAfficherPanneauInfoSupplementaires(!afficherPanneauInfoSupplementaires)}}
              >
                <img
                  src="plus_info.png"
                  alt="Afficher les informations supplémentaires"
                  className="popup-button-image"
                />
              </button>
              )}
            
            <button
                className="popup-button"
                onClick={() => cherchertravailleurs(establishment)}
              >
                <img
                  src="icon-ps.png"
                  alt="Modifier"
                  className="popup-button-image"
                />
              </button>
              
              <button
                className="popup-button"
                onClick={() => {setUtilisateurVeutModifier(true)}}
              >
                <img
                  src="crayon.png"
                  alt="Modifier"
                  className="popup-button-image"
                />
              </button>
              
              <button className="popup-button" onClick={()=>handleOpenURL(establishment)}>
                <img src="URL.png" alt="Go" className="popup-button-image" />
              </button>

            
              

              
              <button
                className="popup-button"
                onClick={() => {
                  const destination = `${establishment.coords[0]},${establishment.coords[1]}`;
                  const openStreetMapUrl = `https://www.openstreetmap.org/directions?engine=fossgis_osrm_car&route=${coordonnéesPointCentral.lat},${coordonnéesPointCentral.lng};${destination}`;
                  window.open(openStreetMapUrl, "_blank");
                }}
              >
                <img
                  src="itineraires_blanc.png"
                  alt="Go"
                  className="popup-button-image"
                />
              </button>
            </div>
          </div>
        ):(<div className="popup-content" style={{width:'auto'}}>
          <div
            style={{display:"flex" , alignItems:"center",justifyContent:'space-between'}}
          >
            <button
              type="button"
              className="popup-button"
              
              onClick={() => setPopupProSante(false)}
            >
              <span style={{ color:'white' }}>←</span>
            </button>
            
            <h2 style={{ margin:'30px', textAlign:'center' }}>Personnel de l'établissement</h2>
            <button style={{}} className="popup-button" onClick={()=>handleAjouterPraticien(establishment)}> 
                <span style={{ fontSize:'35px', color:"white", right:'100%'}}>+</span>
            </button>
            
          </div>
      
          <div style={{ marginTop: "12px" }}>
  <div style={{ 
    maxHeight: "245px", 
    overflowY: "auto",
    border: "1px solid #ddd" 
  }}>
    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead>
        <tr style={{ 
          backgroundColor: "#f2f2f2", 
          textAlign: "left"
        }}>
          <th style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>Nom</th>
          <th style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>Prénom</th>
          <th style={{ 
            padding: "8px",
            borderBottom: "1px solid #ddd",
            minWidth: "150px",
          }}>
            Profession
            <button
              onClick={handleSort}
              style={{
                marginLeft: "5px",
                border: "none",
                background: "transparent",
                cursor: "pointer"
              }}
            >
              {sortOrder === "asc" ? "🔼" : "🔽"}
            </button>
          </th>
          <th style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>Migrer</th>
        </tr>
      </thead>
      <tbody>
        {sortedData.map((personne, index) => (
          <tr key={index}>
            <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{personne.nom}</td>
            <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>{personne.prenom}</td>
            <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>
              {personne.profession}
            </td>
            <td style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>
              <button 
                title="Migrer ce praticien vers un autre établissement" 
                onClick={() => handleMigrer(personne, establishment)} 
                style={{ 
                  cursor: "pointer", 
                  backgroundColor: "transparent",  
                  border: "none", 
                  borderRadius: "4px" 
                }}
              >
                <img src="migrer.png" style={{height: "25px", width: "25px"}} alt="Migrer"/>
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</div>
        </div>
        
        )
      ) : (
          <div className="popup-content">
            <form>
              <button
                type="button"
                style={{ marginLeft: 0 }}
                className="popup-button"
                onClick={() => setUtilisateurVeutModifier(false)}
              >
                <span style={{ right: "90%", color: "white" }}>←</span>
              </button>

              <input
                type="email"
                placeholder="Adresse email"
                className="edit-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <div className="pop-up_modif_container">
                <button
                  title={
                    !modifPermise
                      ? "Vous ne pouvez pas modifier les données d'un établissement avant d'avoir vérifié votre adresse email"
                      : undefined
                  }
                  type="submit"
                  className="pop-up_modif_button"
                  disabled={!modifPermise}
                  onClick={(e) => {
                    e.preventDefault();
                    setShowMenuLateral(false);
                    setOuvrirFenetreModifications(true);
                    setUtilisateurVeutModifier(false);
                    setEstablishmentToModify(establishment);
                  }}
                >
                  Continuer
                </button>
                <button
                  type="button"
                  className="pop-up_modif_touchable"
                  onClick={() => envoyerEmailOuVerification(email, null, "verification")}
                >
                  Vérifier mon email
                </button>
              </div>
            </form>
          </div>
        )}
      </Popup>
      
       
    </Marker>
    </div>
  ));

  
  return afficherClusters ? (
    <MarkerClusterGroup maxClusterRadius={60} spiderfyOnMaxZoom={true} 
    disableClusteringAtZoom={18}>{markers}</MarkerClusterGroup>
  ) : (
    <>{markers}</>
  );
};

export default EtablissementsMarkers;
